// Get salary bonuses
export const GET_SALARY_BONUSES = "GET_SALARY_BONUSES";
export const SET_SALARY_BONUSES = "SET_SALARY_BONUSES";

// Post salary bonus
export const POST_SALARY_BONUS = "POST_SALARY_BONUS";
export const DELETE_SALARY_BONUS = "DELETE_SALARY_BONUS";
export const PATCH_SALARY_BONUS = "PATCH_SALARY_BONUS";

// Loader
export const SALARY_BONUSES_LOADER = "SALARY_BONUSES_LOADER";
